import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const IntegrationPanel = ({ integrations }) => {
  const getStatusBadge = (status) => {
    if (status === 'connected') return { color: 'bg-success/10 text-success', icon: 'CheckCircle', label: 'Connected' };
    if (status === 'disconnected') return { color: 'bg-error/10 text-error', icon: 'XCircle', label: 'Disconnected' };
    return { color: 'bg-warning/10 text-warning', icon: 'AlertCircle', label: 'Warning' };
  };

  const getSyncStatusIcon = (status) => {
    if (status === 'success') return { icon: 'CheckCircle', color: 'var(--color-success)' };
    if (status === 'error') return { icon: 'XCircle', color: 'var(--color-error)' };
    return { icon: 'Clock', color: 'var(--color-warning)' };
  };

  const handleSync = (integrationName) => {
    console.log('Syncing integration:', integrationName);
  };

  const handleConfigure = (integrationName) => {
    console.log('Configuring integration:', integrationName);
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
            Integration & Export
          </h3>
          <p className="text-sm text-muted-foreground">
            Connected accounting systems and data synchronization
          </p>
        </div>
        <Button variant="primary" iconName="Plus" iconPosition="left">
          Add Integration
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {integrations?.map((integration, idx) => {
          const statusBadge = getStatusBadge(integration?.status);
          const syncStatus = getSyncStatusIcon(integration?.syncStatus);
          return (
            <div key={idx} className="bg-muted/50 rounded-lg p-4 hover:bg-muted transition-colors duration-250">
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 rounded-lg bg-card flex items-center justify-center">
                  <Icon name={integration?.icon} size={24} color="var(--color-primary)" />
                </div>
                <span className={`text-xs px-2 py-1 rounded-full ${statusBadge?.color} flex items-center gap-1`}>
                  <Icon name={statusBadge?.icon} size={10} />
                  {statusBadge?.label}
                </span>
              </div>
              <h4 className="text-base font-semibold text-foreground mb-2">{integration?.name}</h4>
              <div className="space-y-2 mb-4">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-muted-foreground">Last Sync:</span>
                  <span className="text-foreground font-medium">{integration?.lastSync}</span>
                </div>
                {integration?.status === 'connected' && (
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-muted-foreground">Records:</span>
                    <div className="flex items-center gap-1">
                      <Icon name={syncStatus?.icon} size={12} color={syncStatus?.color} />
                      <span className="text-foreground font-medium data-text">{integration?.recordsSynced}</span>
                    </div>
                  </div>
                )}
              </div>
              <div className="flex items-center gap-2">
                {integration?.status === 'connected' ? (
                  <>
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="RefreshCw"
                      iconPosition="left"
                      onClick={() => handleSync(integration?.name)}
                      className="flex-1"
                    >
                      Sync
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="Settings"
                      onClick={() => handleConfigure(integration?.name)}
                    >
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="primary"
                    size="sm"
                    iconName="Link"
                    iconPosition="left"
                    onClick={() => handleConfigure(integration?.name)}
                    className="flex-1"
                  >
                    Connect
                  </Button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IntegrationPanel;